import LastOperations from './LastOperations';

export default LastOperations;
